import { parseUnidade } from "../constants/unidades";

// filtros
function selectPorUnidade(cursos, unidade) {
    unidade = unidade.toUpperCase();
    cursos = cursos.filter(curso => unidade === parseUnidade(curso.unidade));
    return cursos;
}

function selectPorModalidade(cursos, modalidade) {
    cursos = cursos.filter(curso => {
        if(modalidade === "Todas") {
            return curso.modalidade;
        } else {
            return curso.modalidade ===  modalidade
        }
    });
    return cursos
}

function ordemAlfabeticaPorCurso(cursos) {
    cursos = cursos.sort((a, b) => {
        if(a.curso > b.curso) return 1;
        if (a.curso < b.curso) return -1;
        else return 0;
    });
    return cursos
}

// formatação de valores
function formataValor(valor) {
    if(valor !== null && valor !== undefined) {
        valor = valor.toLocaleString("pt-BR", { maximumFractionDigits: 2 , style: 'decimal' })
    } 
    else {
        valor = "-"
    }
    return valor;
}

// formatação de valores monetários
function formataValorMoeda(valor) {
    if(valor !== null && valor !== undefined) {
        valor = valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' })
    } 
    else {
        valor = "-"
    }
    return valor;
}

function formataMes(mes) {
    let meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    return meses[mes];
}

export default { 
    parseUnidade,
    selectPorUnidade,
    selectPorModalidade,
    ordemAlfabeticaPorCurso,
    formataValor,
    formataValorMoeda,
    formataMes
}